export const actionTypes = {
  REQUEST_START: 'TAPS.MOVEMENT_REPORT_LIST.REQUEST_START',
  REQUEST_SUCCESS: 'TAPS.MOVEMENT_REPORT_LIST.REQUEST_SUCCESS',
  REQUEST_FAILURE: 'TAPS.MOVEMENT_REPORT_LIST.REQUEST_FAILURE',
};

export function startRequest() {
  return {
    type: actionTypes.REQUEST_START,
  };
}

export function requestSuccess(data) {
  return {
    type: actionTypes.REQUEST_SUCCESS,
    payload: data,
  };
}

export function requestFailure(error) {
  return {
    type: actionTypes.REQUEST_FAILURE,
    payload: error,
  };
}
